<ion-textarea [autoGrow]="autoGrow" [maxlength]="maxlength" [placeholder]="placeholder" [readonly]="readonly"
    [rows]="rows" [value]="displayValue$ | async" class="bordered"></ion-textarea>